import React from 'react'
import { useStateContext } from '../Context/ContextProvider';
import FBRInvoiceQRCode from '../Fbr/FBRInvoiceQRCode';

function PrintSaleInvoice(props) {
  const {weburl, currency} = useStateContext();
  const checkfreshinvoice = '1';
  const decideCustomer = localStorage.getItem('creditcash') ? localStorage.getItem('creditcash') : '1';
  const pos = localStorage.getItem('pos') || '1';
  
  // Thermal printer styles (pos === '0')
  const thermalStyles = {
    container: {
      textAlign: 'right',
      padding: '0px',
      fontFamily: 'monospace', // Better for thermal printers
      fontSize: '12px',
      width: '80mm', // Standard thermal printer width
      maxWidth: '80mm',
      margin: '0 auto'
    },
    centered: {
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'monospace',
      border: '1px solid gray',
    },
    h1: {
      display: 'inline-block',
      fontSize: '12px',
      fontFamily: 'monospace',
    },
    table: {
      borderCollapse: 'collapse',
      width: '100%',
      fontSize: '10px'
    },
    th: {
      border: '1px solid black',
      fontSize: '10px',
      fontFamily: 'monospace',
      padding: '2px'
    },
    td: {
      padding: '2px',
      border: '1px solid #ddd'
    }
  };
  
  // Page invoice styles (pos !== '0')
  const pageStyles = {
    container: {
      width: '140mm', // Standard A6 width
      maxWidth: '140mm',
      margin: '0 auto',
      padding: '5px',
      fontFamily: 'Times New Roman',
      fontSize: '12px'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '11px'
    },
    th: {
      border: '1px solid #ddd',
      padding: '3px',
      textAlign: 'center'
    },
    td: {
      border: '1px solid #ddd',
      padding: '3px'
    }
  };
/*
  const total = props.data.letter.reduce((acc, item) => {
    const value = parseFloat(item.qty * item.unitsaleprice);
    return isNaN(value) ? acc : acc + value;
  }, 0);
  */
const total = (props.data?.letter || []).reduce((acc, item) => {
  const value = parseFloat(item.qty * item.unitsaleprice);
  return isNaN(value) ? acc : acc + value;
}, 0);
// Safe calculation for subtotaldiscount
const subtotaldiscount = (props.data?.letter || []).reduce((acc, item) => {
  const value = parseFloat(item.subtotaldiscount);
  return isNaN(value) ? acc : acc + value;
}, 0);

// Safe calculation for totalqty
const totalqty = (props.data?.letter || []).reduce((acc, item) => {
  const value = parseFloat(item.qty);
  return isNaN(value) ? acc : acc + value;
}, 0);

// Safe calculation for totalweight
const totalweight = (props.data?.letter || []).reduce((acc, item) => {
  const value = parseFloat(item.qty * item.weight);
  return isNaN(value) ? acc : acc + value;
}, 0);
  /*
  const totalpack = props.data.letter.reduce((acc, item) => {
    const value = Math.floor(item.qty / item.pack_size);
    return isNaN(value) ? acc : acc + value;
  }, 0);
*/
  // Thermal Printer Invoice (pos === '0')
  if (pos === '0') {
    return (
      <div id='printablearea' style={thermalStyles.container}>
        <center>
          <img 
            style={{height: '60px', width: '60px'}} 
            src={`${weburl}${props.data.detail.logo}`} 
            alt="logo"
          />
        </center>
        
        <div style={{textAlign: 'center'}}>
          <h3 style={{textAlign: 'center', marginBottom: '2px', fontSize: '14px'}}>
            {props.data.detail.slogan_heading} 
          </h3>
          <h5 style={{textAlign: 'center', marginBottom: '2px', fontSize: '10px'}}>
            Ph: +92 300-6994971
          </h5>
          <p style={{textAlign: 'center', marginBottom: '2px', fontSize: '9px'}}>
            {props.data.detail.slogan_subheading}
          </p>
          <p style={{textAlign: 'center', fontSize: '9px'}}>
            Invoice No: <span>{props.data.invoiceno}</span><br/>
            Time&Date: <span>{props.data.printingtime} - {props.data.manualdate}</span>
          </p>
        </div>
        
        <table style={thermalStyles.table}>
          <thead>
            <tr>
              <th style={thermalStyles.th}>Sr</th>
              <th style={thermalStyles.th}>Item</th>
              <th style={thermalStyles.th}>Qty</th>
              <th style={thermalStyles.th}>Rate</th>
              <th style={thermalStyles.th}>Total</th>
            </tr>
          </thead>
          <tbody id="printcartfortsp100">
            {props.data.letter && props.data.letter.map((item, index) => (
              <tr key={index}>
                <td style={thermalStyles.centered}>{index + 1}</td>
                <td style={{...thermalStyles.centered, fontSize: '9px'}}>{item.name}</td>
                <td style={thermalStyles.centered}>{item.qty}</td>
                <td style={thermalStyles.centered}>{item.unitsaleprice}</td>
                <td style={thermalStyles.centered}>{item.qty * item.unitsaleprice}</td>
              </tr>
            ))}
          </tbody>
        </table>
        
        <div style={{textAlign: 'center', marginTop: '4px', fontSize: '11px'}}>
          <b>Total: <span>{currency}{parseFloat(props.data.grandtotal).toFixed(2)}</span></b>
        </div>
        
        {parseFloat(props.data.shipping).toFixed(2) > '0.00' && (
          <div style={{textAlign: 'center', fontSize: '11px'}}>
            <b>Shipping: <span>{currency}{parseFloat(props.data.shipping).toFixed(2)}</span></b>
          </div>
        )}
        
        <div style={{textAlign: 'center', fontSize: '11px'}}>
          <b>GST/HST: <span>{currency}{parseFloat(props.data.salestax).toFixed(2)}</span></b>
        </div>
        
        <div style={{textAlign: 'center', fontSize: '11px'}}>
          <b>Total With GST: <span>{currency}{parseFloat((parseFloat(props.data.grandtotal) + parseFloat(props.data.salestax) + parseFloat(props.data.shipping))).toFixed(2)}</span></b>
        </div>
        
        {parseFloat(props.data.discount).toFixed(2) > '0.00' && (
          <>
            <div style={{textAlign: 'center', fontSize: '11px'}}>
              <b>Discount: <span>{currency}{parseFloat(props.data.discount).toFixed(2)}</span></b>
            </div>
            <div style={{textAlign: 'center', fontSize: '11px'}}>
              <b>Total After Discount: <span>{currency}{parseFloat(parseFloat(props.data.remainingbill) + parseFloat(props.data.salestax)).toFixed(2)}</span></b>
            </div>
          </>
        )}
        
        {checkfreshinvoice === props.data.indicator && decideCustomer === '1' && (
          <>
            <div style={{textAlign: 'center', fontSize: '11px'}}>
              <b>Payment: <span>{currency}{parseFloat(props.data.entercash).toFixed(2)}</span></b>
            </div>
            <div style={{textAlign: 'center', fontSize: '11px'}}>
              <b>Return: <span>{currency}{parseFloat(parseFloat(props.data.entercash) - (parseFloat(props.data.recovery) + parseFloat(props.data.payment))).toFixed(2)}</span></b>
            </div>
          </>
        )}
        
        {checkfreshinvoice !== props.data.indicator && (
          <div style={{textAlign: 'center', fontSize: '11px'}}>
            <b>Paid Amount: <span>{currency}{parseFloat((parseFloat(props.data.recovery) + parseFloat(props.data.payment))).toFixed(2)}</span></b>
          </div>
        )}
        
        <center>
          <span style={{marginTop: '5px', fontFamily: 'monospace'}}>
            <div style={{marginBottom: '8px'}}>
              <span style={{fontSize: '11px', fontWeight: 'bold'}}>Thanks for having meal</span> 
            </div>
            😊
          </span>
        </center>
      </div>
    );
  }
  
  // Page Invoice (pos !== '0')
  return (
    <div id='printablearea' style={pageStyles.container}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid black',
        paddingBottom: '5px',
        marginBottom: '10px'
      }}>
        <div style={{flex: 1,textAlign: 'center'}}>
          <h1 style={{marginBottom: '2px', fontSize: '16px'}}>{props.data.detail.slogan_heading}</h1>
          <center>
            <b><span style={{textDecoration: 'underline', fontSize: '12px'}}>{props.data.detail.slogan_subheading}</span></b>
            <br/>
            Ph: +92 341 4701626
          </center>
        </div>
        
        <div style={{textAlign: 'right'}}>
          <img 
            style={{height: '60px', width: '60px'}} 
            src={`${weburl}${props.data.detail.logo}`} 
            alt="logo"
          />
        </div>
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '10px',
        gap: '10px'
      }}>
        <div style={{
          border: '1px solid black',
          borderRadius: '8px',
          padding: '8px',
          flex: 1,
          fontSize: '11px'
        }}>
          <div style={{marginBottom: '2px'}}>
            <b>Name:</b> <span style={{fontWeight: 'bold'}}>{props.data.customer.name}</span>
          </div>
          <div style={{marginBottom: '2px'}}>
            <b>Address:</b> <span>{props.data.customeraddress}</span>
          </div>
          <div style={{marginBottom: '2px'}}>
            <b>Phone:</b> <span>{props.data.customer.phone}</span>
          </div>
          <div style={{marginBottom: '2px'}}>
            <b>Id Card:</b> <span>{props.data.customer.cnic}</span>
          </div>
          <div style={{marginBottom: '2px'}}>
            <b>Status:</b> <span>{props.data.customer.secondname === '0' ? 'Filer' : 'Non-Filer'}</span>
          </div>
        </div>
        
        <div style={{
          border: '1px solid black',
          padding: '8px',
          flex: 1,
          borderRadius: '8px',
          fontSize: '11px'
        }}>
          <div>
            <b>Salesman Name:</b> <span>{props.data.salesman.name}</span>
          </div>
          <div>
            <b>Salesman Phone:</b> <span>{props.data.salesman.phone}</span>
          </div>
          <div>
            <b>Invoice Date:</b> <span>{props.data.manualdate}</span>
          </div>
          <div>
            <b>Invoice:</b> <span>{props.data.invoiceno}</span>
          </div>
        </div>
      </div>

      <div style={{
        border: '1px solid black',
        marginTop: '10px',
        fontSize: '10px'
      }}>
        <table style={pageStyles.table}>
          <thead>
            <tr>
              <th style={pageStyles.th}>Sr#</th>
              <th style={{...pageStyles.th, textAlign: 'left'}}>Item Name</th>
              <th style={pageStyles.th}>Qty</th>
              <th style={pageStyles.th}>Weight</th>
              <th style={pageStyles.th}>Rate</th>
              <th style={pageStyles.th}>Sub Total</th>
              <th style={pageStyles.th}>Discount</th>
              <th style={pageStyles.th}>Total</th>
            </tr>
          </thead>
          <tbody id="printcartreciept">
            {props.data.letter && props.data.letter.map((item, index) => (
              <tr key={index}>
                <td style={{...pageStyles.td, textAlign: 'center'}}>{index + 1}</td>
                <td style={{...pageStyles.td, textAlign: 'left'}}>{item.name}</td>
                <td style={{...pageStyles.td, textAlign: 'center'}}>{item.qty}</td>
                <td style={{...pageStyles.td, textAlign: 'center'}}>{(item.qty * item.weight).toFixed(2)}</td>
                <td style={{...pageStyles.td, textAlign: 'center'}}>{item.unitsaleprice}</td>
                <td style={{...pageStyles.td, textAlign: 'center'}}>{(item.qty * item.unitsaleprice).toFixed(2)}</td>
                <td style={{...pageStyles.td, textAlign: 'center'}}>{item.subtotaldiscount}</td>
                <td style={{...pageStyles.td, textAlign: 'center'}}>
                  {parseFloat((item.qty * item.unitsaleprice) - item.subtotaldiscount).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td style={pageStyles.td} colSpan="2" >Total</td>
              <td style={{...pageStyles.td, textAlign: 'center'}}>{totalqty.toFixed(2)}</td>
              <td style={{...pageStyles.td, textAlign: 'center'}}>{totalweight.toFixed(2)}</td>
              <td style={{...pageStyles.td, textAlign: 'center'}}></td>
              <td style={{...pageStyles.td, textAlign: 'center'}}>{total.toFixed(2)}</td>
              <td style={{...pageStyles.td, textAlign: 'center'}}>{subtotaldiscount.toFixed(2)}</td>
              <td style={{...pageStyles.td, textAlign: 'center'}}>
                {parseFloat(total - subtotaldiscount).toFixed(2)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div style={{display:'flex',justifyContent:'space-between'}}>

   
<div style={{
float: 'left',
        padding: '10px',
        marginTop: '10px',
        width: '100%',
        fontSize: '11px'

}}>



{props.data.qrcode && (
    <FBRInvoiceQRCode qrcode={props.data.qrcode}/>  
)}
</div>
      <div style={{
        float: 'right',
        padding: '10px',
        marginTop: '10px',
        width: '100%',
        fontSize: '11px'
      }}>
        <div style={{textAlign: 'right'}}>
          <b>Total Bill: <span>{currency}{parseFloat(props.data.grandtotal).toFixed(2)}</span></b>
        </div>
        
        {parseFloat(props.data.discount).toFixed(2) > '0.00' && (
          <div style={{textAlign: 'right'}}>
            <b>Discount: <span>{currency}{parseFloat(props.data.discount).toFixed(2)}</span></b>
          </div>
        )}
        
        {parseFloat(props.data.shipping).toFixed(2) > '0.00' && (
          <div style={{textAlign: 'right'}}>
            <b>Shipping: <span>{currency}{parseFloat(props.data.shipping).toFixed(2)}</span></b>
          </div>
        )}
        
        {parseFloat(props.data.discount).toFixed(2) > '0.00' && (
          <div style={{textAlign: 'right'}}>
            <b>Total After Discount: <span>{currency}{parseFloat((parseFloat(props.data.grandtotal) + parseFloat(props.data.shipping) - parseFloat(props.data.discount))).toFixed(2)}</span></b>
          </div>
        )}
        
        {parseFloat(props.data.salestax).toFixed(2) > '0.00' && (
          <div style={{textAlign: 'right'}}>
            <b>Adv.Tax: <span>{currency}{parseFloat(props.data.salestax).toFixed(2)}</span></b>
          </div>
        )}
        
        {parseFloat(props.data.discount).toFixed(2) > '0.00' && (
          <div style={{textAlign: 'right'}}>
            <b>Net Amount: <span>{currency}{parseFloat(parseFloat(props.data.remainingbill) + parseFloat(props.data.salestax)).toFixed(2)}</span></b>
          </div>
        )}
        
        <div style={{textAlign: 'right'}}>
          <b>Pre Balance: <span>{currency}{parseFloat(props.data.pbalance).toFixed(2)}</span></b>
        </div>
        
        <div style={{textAlign: 'right'}}>
          <b>Total Bill: <span>{currency}{parseFloat(parseFloat(props.data.pbalance) + parseFloat(props.data.remainingbill) + parseFloat(props.data.salestax)).toFixed(2)}</span></b>
        </div>
        
        <div style={{textAlign: 'right'}}>
          <b>Payment: <span>{currency}{parseFloat(parseFloat(props.data.recovery) + parseFloat(props.data.payment)).toFixed(2)}</span></b>
        </div>
        
        <div style={{textAlign: 'right', marginTop: '5px'}}>
          <b>Current Balance: <span style={{fontSize: '13px'}}>
            {currency}{parseFloat((parseFloat(props.data.grandtotal) - parseFloat(props.data.discount) + parseFloat(props.data.salestax) - (parseFloat(props.data.payment) + parseFloat(props.data.recovery)) + parseFloat(props.data.pbalance) + parseFloat(props.data.shipping))).toFixed(2)}
          </span></b>
        </div>
      </div>
         </div>
    </div>
  );
}

export default PrintSaleInvoice;